/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionPaymentInfoOffer } from './SubscriptionPaymentInfoOffer';
import {
    SubscriptionPaymentInfoOfferFromJSON,
    SubscriptionPaymentInfoOfferFromJSONTyped,
    SubscriptionPaymentInfoOfferToJSON,
    SubscriptionPaymentInfoOfferToJSONTyped,
} from './SubscriptionPaymentInfoOffer';

/**
 * 
 * @export
 * @interface SubscriptionPaymentInfo
 */
export interface SubscriptionPaymentInfo {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentInfo
     */
    clientSecret?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentInfo
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentInfo
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentInfo
     */
    product: string;
    /**
     * 
     * @type {SubscriptionPaymentInfoOffer}
     * @memberof SubscriptionPaymentInfo
     */
    availableOffer?: SubscriptionPaymentInfoOffer;
}

/**
 * Check if a given object implements the SubscriptionPaymentInfo interface.
 */
export function instanceOfSubscriptionPaymentInfo(value: object): value is SubscriptionPaymentInfo {
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    return true;
}

export function SubscriptionPaymentInfoFromJSON(json: any): SubscriptionPaymentInfo {
    return SubscriptionPaymentInfoFromJSONTyped(json, false);
}

export function SubscriptionPaymentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPaymentInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
        'price': json['price'],
        'currency': json['currency'],
        'product': json['product'],
        'availableOffer': json['availableOffer'] == null ? undefined : SubscriptionPaymentInfoOfferFromJSON(json['availableOffer']),
    };
}

export function SubscriptionPaymentInfoToJSON(json: any): SubscriptionPaymentInfo {
    return SubscriptionPaymentInfoToJSONTyped(json, false);
}

export function SubscriptionPaymentInfoToJSONTyped(value?: SubscriptionPaymentInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientSecret': value['clientSecret'],
        'price': value['price'],
        'currency': value['currency'],
        'product': value['product'],
        'availableOffer': SubscriptionPaymentInfoOfferToJSON(value['availableOffer']),
    };
}

